<template>
  <div>
    <div class="card" id="detail-client">
      <header class="header-card">
        <p>{{ $t('detail.client.title') }}</p>
      </header>
      <div
        :class="{
          'is-justify-content-center': uniquePayeur || intervenant.length === 1,
        }"
        class="card-content columns is-marginless mgb-0 overflow-x-auto">
        <client-payeur-intervenant-card
          v-for="(interv) in intervenant"
          :key="interv.id"
          :intervenant="interv"
          :afficherLienDetail="afficherLienDetail"
          :class="[columnsSize, { 'w-fit-content': intervenant.length === 1 }]"
          class="column client-payeur-intervenant-card"
        />
      </div>
      <section class="columns is-marginless">
        <a
          v-if="!uniquePayeur"
          @click="previousPayeur"
          :class="{'disabled': !index}"
          class="column is-narrow">
          <b-icon
            icon="arrow-left-bold-circle"
            type="is-addOrEdit"
            custom-size="mdi-36px">
          </b-icon>
        </a>
        <div v-if="!uniquePayeur" class="dot-pagination column">
          <div
            v-for="(payeur, payeurIndex) in payeurs"
            :key="payeur.id"
            :class="{'active': payeurIndex === index}">
          </div>
        </div>
        <a v-if="!uniquePayeur"
          @click="nextPayeur"
          :class="{'disabled': index + 1 === payeurs.length}"
          class="column is-narrow">
          <b-icon
            icon="arrow-right-bold-circle"
            type="is-addOrEdit"
            custom-size="mdi-36px">
          </b-icon>
        </a>
      </section>
    </div>
  </div>
</template>

<script>
import clientPayeurIntervenantCard from '@/components/devisCommandes/detailDevisCommande/clientPayeurIntervenantCard';

export default {
  props: {
    payeurs: {
      type: Array,
      required: true,
    },
    intervenantsNonPayeurs: {
      type: Array,
      required: true,
    },
    afficherLienDetail: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    index: 0,
  }),
  components: {
    clientPayeurIntervenantCard,
  },
  computed: {
    selectedPayeur() {
      return this.payeurs[this.index];
    },
    intervenant() {
      return [
        this.selectedPayeur,
        ...this.intervenantsNonPayeurs,
        ...this.payeurs.filter(payeur => {
          return payeur.id !== this.selectedPayeur.id
                 && (payeur.annonceur || payeur.donneurOrdre || payeur.mandataire);
        }),
      ];
    },
    uniquePayeur() {
      return this.payeurs.length === 1;
    },
    columnsSize() {
      if (this.intervenant.length === 2) return 'is-6';
      return 'is-4';
    },
  },
  watch: {
    index() {
      this.$bus.$emit('new-payeur-selected', this.index);
    },
  },
  methods: {
    nextPayeur() {
      this.index += 1;
    },
    previousPayeur() {
      this.index -= 1;
    },
  },
};
</script>
